export default __webpack_public_path__ + "static/media/Highlord's Cloak of Shielding.719854be.jpg";